import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import {
  NETWORK_STATUSES,
  PROVIDER_GROUP_STATUSES,
} from '@backend/db/const/db.const.ENUMS';

import { ProviderGroupsPage } from '@frontend/features/provider-network/pages/ProviderGroupsPage';

const groupsSearchSchema = z.object({
  // Search query
  search: z.string().optional(),

  // Status filters - handle single value or array from URL
  statuses: z.preprocess(
    (val) => {
      if (val === undefined || val === null) return undefined;
      return Array.isArray(val) ? val : [val];
    },
    z.array(z.enum(PROVIDER_GROUP_STATUSES)).optional(),
  ),

  // Network status filters
  networkStatuses: z.preprocess(
    (val) => {
      if (val === undefined || val === null) return undefined;
      return Array.isArray(val) ? val : [val];
    },
    z.array(z.enum([...NETWORK_STATUSES, 'unspecified'] as const)).optional(),
  ),

  // Pagination
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(100000).default(100),

  // Sort state
  sortBy: z
    .enum(['groupName', 'status', 'createdAt', 'clinicCount'])
    .default('groupName'),
  sortOrder: z.enum(['asc', 'desc']).default('asc'),
});

export const Route = createFileRoute('/provider-network/groups/')({
  component: ProviderGroupsPage,
  validateSearch: groupsSearchSchema,
});
